import type { CapacityObligation } from '@/features/bidding/types/capacityObligations'

/**
 * Per-(activation group, PTU) obligation watts, keyed `${activationGroupUuid}-${ptuStartMillis}`.
 * Maps each (activation group, PTU) to its single capacity-obligation volume.
 */
export function computeObligationByActivationGroupPtu(
  obligations: ReadonlyArray<CapacityObligation>,
  ptuLengthInMinutes: number,
): Map<string, number> {
  const byKey = new Map<string, number>()
  for (const obligation of obligations) {
    for (const ptu of obligation.ptus) {
      // Capacity obligation is at 1 hour granularity. Explode that to match Energy 15-min PTU
      for (let slot = ptu.startAt; slot < ptu.endAt; slot = slot.plus({ minutes: ptuLengthInMinutes })) {
        byKey.set(`${obligation.activationGroupUuid}-${slot.toMillis()}`, ptu.volume.quantity)
      }
    }
  }

  return byKey
}
